import { Box } from "@mui/material";

import {
  Banner,
  BannerList,
  Button,
  PopupDialog,
  PopupDialogTitle,
} from "~/components/design-system/index.js";

export function MissingDemographicsDialog({
  open,
  onClose,
  restricted,
}: {
  open: boolean;
  onClose: () => void;
  restricted: boolean;
}) {
  return (
    <PopupDialog open={open} onClose={onClose}>
      <PopupDialogTitle
        titleText={
          restricted
            ? `Patient is restricted`
            : "Patient is missing key demographics"
        }
        closeDialog={onClose}
      />
      <Banner
        bannerType={BannerList.ERROR}
        title={
          restricted
            ? "This patient is marked as restricted in NHS national systems - please add any missing demographics before continuing"
            : "This patient is missing key demographics required for the completion of forms on eMHA - please add any missing demographics before continuing"
        }
      />
      <Box
        sx={{
          width: "100%",
          marginTop: "1rem",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button label="Close" onClick={onClose} />
      </Box>
    </PopupDialog>
  );
}
